//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, minLength } from "vuelidate/lib/validators";
import { eventEmitter } from "@/main.js";
import { mapActions } from "vuex";

const binanceIntervals = ["15m", "30m", "1h", "4h", "1d", "1w"];
const huobiIntervals = ["15min", "30min", "60min", "4hour", "1day", "1week"];
const kucoinIntervals = ["15min", "30min", "1hour", "4hour", "1day", "1week"];

const limit = 20;

export default {
	name: "right-drawer",
	data: () => ({
		tab: "markets",
		fields: null,
		isOpen: false,
		ticker: null,
		wallet: null,
		isEditing: false,
		timeframe: "",
		marketsFavorites: null,
		walletsFavorites: null,
		binanceTimeframes: binanceIntervals,
		huobiTimeframes: huobiIntervals,
		kucoinTimeframes: kucoinIntervals,
		selectedWallets: [],
	}),
	validations: {
		name: { minLength: minLength(4) },
		description: { minLength: minLength(4) },
		price: { minLength: minLength(1) },
	},
	watch: {
		ticker(val) {
			if (val) this.timeframe = "";
		},
		isOpen(val) {
			document.documentElement.style.overflowY = val ? "hidden" : "auto";
		},
	},
	computed: {
		intervalsByExchange() {
			if (this.tickerToSave && this.tickerToSave.exchange === "BINANCE") {
				return this.binanceTimeframes;
			} else if (this.tickerToSave && this.tickerToSave.exchange === "HUOBI") {
				return this.huobiTimeframes;
			} else if (this.tickerToSave && this.tickerToSave.exchange === "KUCOIN") {
				return this.kucoinTimeframes;
			} else {
				return this.binanceTimeframes;
			}
		},
		tickerToSave() {
			if (this.ticker) {
				const id = this.ticker.split("|")[0];
				const exchange = this.ticker.split("|")[1];
				const interval = this.timeframe;
				const ex = this.marketsFavorites.find((e) => e.exchange === exchange);
				if (ex) {
					const fav = ex.favorites.find((f) => f.id === id);
					return fav ? { exchange, ...fav, interval } : {};
				}
			}
			return null;
		},
		walletToSave() {
			return this.selectedWallets ? this.selectedWallets : [];
		},
	},

	methods: {
		...mapActions(["addTile"]),

		closeDrawer() {
			this.isOpen = false;
		},
		selectWallet(w, exchange) {
			const foundIndex = this.selectedWallets.findIndex((el) => el.id === w.id);
			if (foundIndex === -1) {
				this.selectedWallets.push({ exchange: exchange.exchange, ...w });
			} else {
				this.selectedWallets.splice(foundIndex, 1);
			}
		},

		async submitNoteSave() {
			const i = Date.now();
			const position = {
				i,
				x: 0,
				y: 0,
				h: 4,
				w: 6,
				minH: 3,
				minW: 5,
				maxH: 6,
				maxW: 10,
			};
			const tile = {
				i,
				tileType: "note-tile",
				...position,
				props: "",
			};
			const key = await this.addTile({ tile });
			this.closeDrawer();
		},
		async submitWalletSave() {
			if (this.walletToSave) {
				const i = Date.now();
				const position = {
					i,
					x: 0,
					y: 0,
					h: 3,
					w: 6,
					minH: 3,
					minW: 5,
					maxH: 6,
					maxW: 12,
				};
				const tile = {
					i,
					tileType: "wallet-tile",
					...position,
					props: this.walletToSave,
				};
				const key = await this.addTile({ tile });
				this.closeDrawer();
			}
		},
		async submitTickerSave() {
			if (this.tickerToSave) {
				const i = Date.now();
				const position = {
					i,
					x: 0,
					y: 0,
					h: 5,
					w: 5,
					minH: 3,
					minW: 5,
					maxH: 6,
					maxW: 12,
				};
				const tile = {
					i,
					tileType: "ticker-tile",
					...position,
					props: this.tickerToSave,
				};
				await this.addTile({ tile });
				this.closeDrawer();
			}
		},
	},
	created() {
		eventEmitter.$on("add-tile", ({ marketsFavorites, walletsFavorites }) => {
			this.marketsFavorites = marketsFavorites;
			this.walletsFavorites = walletsFavorites;
			this.isOpen = true;
		});
	},
};
